import { createContext,useState } from "react";

import React from 'react'
const ToolbarContext = createContext();
const ToolbarProvider = (props) => {
const [tool,setTool] = useState(null)

  return (
      <ToolbarContext.Provider value={{tool,setTool}}>
          {props.children}
    </ToolbarContext.Provider>
  )
}

export {ToolbarContext,ToolbarProvider}